export default "{{#if docsView}}\r\n  <script type=\"module\" src=\"/{{publicPath}}scripts/main.bundle.js\"></script>\r\n{{/if}}"